import { createStore } from "redux";
import ReducerFunction from "../reducer";

const store = createStore(ReducerFunction)
export default store;